// extracted by mini-css-extract-plugin
export default {"block":"AdminBlock_block__yNxOM","block__title":"AdminBlock_block__title__6ivuz","block__value":"AdminBlock_block__value__x3yDD","block__link":"AdminBlock_block__link__4Z6Rg"};